var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                _vm._b({}, "el-col", _vm.gridl, false),
                [_c("left", { on: { clickType: _vm.clickType } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                _vm._b(
                  { staticClass: "assess-right" },
                  "el-col",
                  _vm.gridr,
                  false
                ),
                [
                  _c("div", { staticClass: "header" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.title) + "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "tips" }, [
                      _vm._v("列表支持拖拽排序"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "table",
                      staticClass: "table",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.list, "row-key": "id" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "职位",
                          "min-width": "200",
                          prop: "position",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: scope.row.show,
                                        expression: "scope.row.show",
                                      },
                                    ],
                                    attrs: {
                                      "collapse-tags": "",
                                      filterable: "",
                                      multiple: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: scope.row.position,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "position", $$v)
                                      },
                                      expression: "scope.row.position",
                                    },
                                  },
                                  _vm._l(_vm.options, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        disabled: _vm.selectedList.includes(
                                          item.id
                                        ),
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !scope.row.show,
                                        expression: "!scope.row.show",
                                      },
                                    ],
                                  },
                                  [
                                    scope.row.positions
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                scope.row.positions
                                                  .map(function (item) {
                                                    return item.name
                                                  })
                                                  .join("、")
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        { attrs: { label: "固定工资" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "基本工资",
                              "min-width": "100",
                              prop: "benefit.basicSalary",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.show,
                                          expression: "scope.row.show",
                                        },
                                      ],
                                      attrs: {
                                        oninput: "if(value<0)value=0",
                                        placeholder: "请输入",
                                        type: "number",
                                      },
                                      model: {
                                        value: scope.row.benefit.basicSalary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row.benefit,
                                            "basicSalary",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.benefit.basicSalary",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !scope.row.show,
                                            expression: "!scope.row.show",
                                          },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.benefit.basicSalary)
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "绩效工资",
                              "min-width": "100",
                              prop: "benefit.performance",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.show,
                                          expression: "scope.row.show",
                                        },
                                      ],
                                      attrs: {
                                        precision: 2,
                                        oninput: "if(value<0)value=0",
                                        placeholder: "请输入",
                                        type: "number",
                                      },
                                      model: {
                                        value: scope.row.benefit.performance,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row.benefit,
                                            "performance",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.benefit.performance",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !scope.row.show,
                                            expression: "!scope.row.show",
                                          },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.benefit.performance)
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "合计",
                              "min-width": "100",
                              prop: "total",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.getTotal(scope.row.benefit))
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        { attrs: { label: "效益工资" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "100",
                              prop: "benefit.commission",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          content: "可输入百分比（%）",
                                          placement: "top",
                                          trigger: "hover",
                                          width: "170",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v("提成工资 "),
                                            _c("span", {
                                              staticClass: "el-icon-info",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.show,
                                          expression: "scope.row.show",
                                        },
                                      ],
                                      attrs: { placeholder: "请输入" },
                                      model: {
                                        value: scope.row.benefit.commission,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row.benefit,
                                            "commission",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.benefit.commission",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !scope.row.show,
                                            expression: "!scope.row.show",
                                          },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.benefit.commission)
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "100",
                              prop: "benefit.teamAward",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          content: "可输入百分比（%）",
                                          placement: "top",
                                          trigger: "hover",
                                          width: "170",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v("团队奖 "),
                                            _c("span", {
                                              staticClass: "el-icon-info",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.show,
                                          expression: "scope.row.show",
                                        },
                                      ],
                                      attrs: { placeholder: "请输入" },
                                      model: {
                                        value: scope.row.benefit.teamAward,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row.benefit,
                                            "teamAward",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.benefit.teamAward",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !scope.row.show,
                                            expression: "!scope.row.show",
                                          },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.benefit.teamAward)
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "100",
                              prop: "benefit.dividends",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          content: "可输入百分比（%）",
                                          placement: "top",
                                          trigger: "hover",
                                          width: "170",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v("分红 "),
                                            _c("span", {
                                              staticClass: "el-icon-info",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.show,
                                          expression: "scope.row.show",
                                        },
                                      ],
                                      attrs: { placeholder: "请输入" },
                                      model: {
                                        value: scope.row.benefit.dividends,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row.benefit,
                                            "dividends",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.benefit.dividends",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !scope.row.show,
                                            expression: "!scope.row.show",
                                          },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.benefit.dividends)
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { fixed: "right", label: "操作", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.show == false
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "hr:training:promotion:edit",
                                            ],
                                            expression:
                                              "['hr:training:promotion:edit']",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editFn(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.show == true
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "hr:training:promotion:edit",
                                            ],
                                            expression:
                                              "['hr:training:promotion:edit']",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRow(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("保存")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "hr:training:promotion:details",
                                        ],
                                        expression:
                                          "['hr:training:promotion:details']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCheck(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("晋升标准")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["hr:training:promotion:delete"],
                                        expression:
                                          "['hr:training:promotion:delete']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDelete(scope)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["hr:training:promotion:add"],
                          expression: "['hr:training:promotion:add']",
                        },
                      ],
                      staticClass: "add-row",
                      on: { click: _vm.addANewLine },
                    },
                    [
                      _c("span", { staticClass: "el-icon-plus" }),
                      _vm._v(" 添加行\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.editDrawer,
            direction: "rtl",
            size: "60%",
            title: "晋升标准",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDrawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "check-box" },
            [
              _c("div", { staticClass: "user-name mb20" }, [
                _c("span", [_vm._v("职位：")]),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.positions
                        .map(function (obj) {
                          return obj.name
                        })
                        .join("、")
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.editDrawer
                ? _c("ueditorFrom", {
                    ref: "ueditorFrom",
                    attrs: {
                      border: true,
                      content: _vm.content,
                      height: _vm.height,
                    },
                    on: { input: _vm.ueditorEdit },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }